import { render } from "./LoginCompanies.vue?vue&type=template&id=6c104a38"
import script from "./LoginCompanies.vue?vue&type=script&lang=js"
export * from "./LoginCompanies.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__